import appConfig from "./app.module.json";

const { KEY_USER, KEY_USER_REMEMBER } = appConfig;

export { KEY_USER, KEY_USER_REMEMBER };
